/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiVideoConferenceSettingsFromJSON, StreemApiVideoConferenceSettingsToJSON, } from './';
export function StreemApiExpertTradeAreaFromJSON(json) {
    return StreemApiExpertTradeAreaFromJSONTyped(json, false);
}
export function StreemApiExpertTradeAreaFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'expertAreaIcon': !exists(json, 'expert_area_icon') ? undefined : json['expert_area_icon'],
        'tradeId': !exists(json, 'trade_id') ? undefined : json['trade_id'],
        'videoConferenceSettings': !exists(json, 'video_conference_settings') ? undefined : StreemApiVideoConferenceSettingsFromJSON(json['video_conference_settings']),
    };
}
export function StreemApiExpertTradeAreaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'description': value.description,
        'expert_area_icon': value.expertAreaIcon,
        'trade_id': value.tradeId,
        'video_conference_settings': StreemApiVideoConferenceSettingsToJSON(value.videoConferenceSettings),
    };
}
//# sourceMappingURL=StreemApiExpertTradeArea.js.map